export enum PlatformAvailability {
  IMMEDIATE = 'immediate',
  IN_1_MONTH = 'in-1-month',
  IN_2_MONTHS = 'in-2-months',
  IN_3_MONTHS = 'in-3-months',
  MORE_THAN_3_MONTHS = 'more-than-3-months',
}
